<template>
<div id="app">
	<tpl-header></tpl-header>
	<!-- <router-view  /> -->
	<transition name="fade">
		<router-view  />
	</transition>
	<tpl-footer></tpl-footer>
	
</div>
</template>

<script>
import tplHeader from'./components/header/index.vue'	//通用固定头部
import tplFooter from'./components/footer/index.vue'	//通用固定底部
export default {
	name: 'App',
	components:{
		'tpl-header':tplHeader,
		'tpl-footer':tplFooter,
	},
	data(){
		return {
		}
	},
	created() {

		
	},
	methods:{
		
	}
}
</script>

<style lang="less">
@import '~@/assets/css/reset.less';
@import '~@/assets/css/common.less';
</style>



// WEBPACK FOOTER //
// src/App.vue